import { render } from "./CdataOltInfo.vue?vue&type=template&id=0c58715d"
import script from "./CdataOltInfo.vue?vue&type=script&lang=js"
export * from "./CdataOltInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\oltcare-front\\olt_care\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__